import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useRef,
} from 'react';
import { Button } from '../../../../components/Button/Button';
import { Modal, ModalRef } from '../../../../components/Modal/Modal';
import { useLanguage } from '../../../../locale/useLanguage';

type PdrHoursModalProps = {
  hoursPdr: string;
};

export const PdrHoursModal: React.ForwardRefExoticComponent<
  PdrHoursModalProps & React.RefAttributes<ModalRef>
> = forwardRef(({ hoursPdr }, forwardedRef) => {
  const [t] = useLanguage();
  const modalRef = useRef<ModalRef>(null);

  useImperativeHandle(forwardedRef, () => ({
    openModal: modalRef.current!.openModal,
    closeModal: modalRef.current!.closeModal,
  }));

  const close = useCallback(() => {
    modalRef.current?.closeModal();
  }, []);

  return (
    <Modal ref={modalRef}>
      <div className="modal-pdr-hours--container">
        <h2 className="modal-pdr-hours--title">
          {t('cart.openingHoursModal')}
        </h2>
        <p className="modal-pdr-hours--text">{hoursPdr}</p>
      </div>
      <div className="modal-button-container">
        <Button onClick={close} label={t('errorModal.modalCloseButton')} />
      </div>
    </Modal>
  );
});
